/**
 * Health insurance application V2 step slugs - single source of truth.
 *
 * Lives in shared/ because three consumers outside the app read these routes:
 * nuxt.config.ts route rules, server/plugins/csp-nonce.ts and
 * server/plugins/strip-optimizely-payment-hints.ts. Those three hardcoded
 * `step8` for payment and were missed when HI-1296 inserted the
 * acknowledgement and review steps, pushing payment to `step10` - which left
 * the real payment page without its per-request CSP nonce.
 *
 * Re-exported by app/constants/application/health-insurance-v2 so app code can
 * keep importing from there.
 */
export const COMPARE_STEP = 'step0'
export const PERSONAL_DETAILS_STEP = 'step1'
export const PARTNER_DETAILS_STEP = 'step2'
export const CHILDREN_DETAILS_STEP = 'step3'
export const REBATE_STEP = 'step4'
export const LHC_STEP = 'step5'
export const CHOOSE_EXTRAS_STEP = 'step6'
export const MEDICARE_STEP = 'step7'
export const ACKNOWLEDGEMENT_STEP = 'step8'
export const REVIEW_STEP = 'step9'
export const PAYMENT_STEP = 'step10'

const stepNumber = (step: string): number => Number(step.replace('step', ''))

export const COMPARE_STEP_NUMBER = stepNumber(COMPARE_STEP)
export const PERSONAL_DETAILS_STEP_NUMBER = stepNumber(PERSONAL_DETAILS_STEP)
export const PARTNER_DETAILS_STEP_NUMBER = stepNumber(PARTNER_DETAILS_STEP)
export const CHILDREN_DETAILS_STEP_NUMBER = stepNumber(CHILDREN_DETAILS_STEP)
export const REBATE_STEP_NUMBER = stepNumber(REBATE_STEP)
export const LHC_STEP_NUMBER = stepNumber(LHC_STEP)
export const CHOOSE_EXTRAS_STEP_NUMBER = stepNumber(CHOOSE_EXTRAS_STEP)
export const MEDICARE_STEP_NUMBER = stepNumber(MEDICARE_STEP)
export const ACKNOWLEDGEMENT_STEP_NUMBER = stepNumber(ACKNOWLEDGEMENT_STEP)
export const REVIEW_STEP_NUMBER = stepNumber(REVIEW_STEP)
export const PAYMENT_STEP_NUMBER = stepNumber(PAYMENT_STEP)
